<template>
  <div>
    <template v-for="item in list">
      <el-menu-item v-if="(!item.children || !item.children.length || item.hideChildren)" :key="'menu-item'+item.path" :index="item.path" :disabled="item.disabled"
                    :style="{display:item.hide?'none':false}">
        <i v-if="item.icon" class="icon" :class="item.icon" style="margin-right: 5px;"></i>
        <span slot="title" :title="item.menuName">{{item.menuName}}</span>
      </el-menu-item>
      <el-submenu v-if="(item.children && item.children.length)" :key="'submenu'+item.path" :index="item.path" :style="{display:item.hideChildren?'none':false}">
        <template slot="title">
          <i v-if="item.icon" class="icon" :class="item.icon" style="margin-right: 5px;"></i>
          <span slot="title" :title="item.menuName">{{item.menuName}}</span>
        </template>
        <MenuTree :list="item.children"></MenuTree>
      </el-submenu>
    </template>
  </div>
</template>
<script>
export default {
  name: 'MenuTree',
  props: ['list'],
  components: {},
  data () {
    return {}
  }
}
</script>
<style>
</style>
